// extracted by mini-css-extract-plugin
export default {"form":"style_form__NdRn8","formInputBlock":"style_formInputBlock__xV1tF","formInputBlock2":"style_formInputBlock2__+yM5e","formInput":"style_formInput__dK5vB"};